import React from 'react';
import { Tab as MaterialUiTab, TabProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';
import { makeStyles } from '~/UIKit/Style';
import { CHARCOAL_GREY } from '~/Constants/Colors.constants';
import { FONT_SIZE_MEDIUM_INBETWEEN } from '~/Constants/UI.constants';

interface ITabProps extends TabProps, ISharedProps {}

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    textTransform: 'capitalize',
    marginRight: 30,
    padding: 0,
    minWidth: 120,
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    fontWeight: 300,
    color: CHARCOAL_GREY,
    '&:last-of-type': {
      marginRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  tabSelected: {
    fontWeight: 'bold',
  },
}));

export const Tab = ({ ...props }: ITabProps) => {
  const { classes } = useStyles();

  return (
    <MaterialUiTab
      classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
      color="primary"
      {...props}
    />
  );
};
